import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {

  isAndroid(): boolean {
    return /Android/i.test(navigator.userAgent);
  }

  isIOS(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  isDesktop(): boolean {
    return !(this.isAndroid() || this.isIOS());
  }

  public isAppleDevice(): boolean {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    if (this.isIOS()) {
      return true;
    }
    const isMac = /Macintosh/i.test(ua);
    if (isMac) {
      return true;
    }
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  }
}
